import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Spinner, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import WebService from "../../../Services/WebService";

const ExaminerSettings = () => {
  const [loading, setLoading] = useState(false);
  const [availability, setAvailability] = useState<any[]>([
    { day_of_week: "Monday", is_active: false, start_time: "", end_time: "" },
    { day_of_week: "Tuesday", is_active: false, start_time: "", end_time: "" },
    {
      day_of_week: "Wednesday",
      is_active: false,
      start_time: "",
      end_time: "",
    },
    { day_of_week: "Thursday", is_active: false, start_time: "", end_time: "" },
    { day_of_week: "Friday", is_active: false, start_time: "", end_time: "" },
    { day_of_week: "Saturday", is_active: false, start_time: "", end_time: "" },
    { day_of_week: "Sunday", is_active: false, start_time: "", end_time: "" },
  ]);
  const [autoAccept, setAutoAccept] = useState(false);
   const [examAmount, setExamAmount] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [timeZones, setTimeZones] = useState([
    "Asia/Kolkata",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Athens",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Bratislava",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Dublin",
    "Europe/Gibraltar",
    "Europe/Helsinki",
    "Europe/Istanbul",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Lisbon",
    "Europe/Ljubljana",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Oslo",
    "Europe/Paris",
    "Europe/Podgorica",
    "Europe/Prague",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/San_Marino",
    "Europe/Sarajevo",
    "Europe/Skopje",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Uzhgorod",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zagreb",
    "Europe/Zaporozhye",
    "Europe/Zurich",
  ]);

  // ✅ Fetch settings on mount
  useEffect(() => {
    setLoading(true);
    WebService.getAPI({ action: "/examiner/settings" })
      .then((res: any) => {
        const data = res?.result || {};
        const slots = data.availability || [];
        const defaultDays = [...availability];

        // merge existing days with DB values
        const merged = defaultDays.map((day) => {
          const match = slots.find(
            (s: any) =>
              s.day_of_week?.toLowerCase() === day.day_of_week.toLowerCase()
          );
          return match
            ? {
                ...day,
                is_active: !!match.is_active,
                start_time: match.start_time || "",
                end_time: match.end_time || "",
              }
            : day;
        });
      // setExamAmount(res.result.exam_amount);
        setAvailability(merged);
        setAutoAccept(data.examiner_settings?.exam_auto_acceptance === "ON");
      //  setMaxCapacity(data.examiner_settings?.max_capacity_per_session || "");
        setTimeZone(
          data.examiner_settings?.examiner_time_zone || "Europe/Amsterdam"
        );
      })
      .catch(() => {
        toast.error("Failed to fetch examiner settings");
      })
      .finally(() => setLoading(false));
  }, []);

  // ✅ Handle toggle ON/OFF for each day
  const handleToggle = (index: number) => {
    const updated = [...availability];
    updated[index].is_active = !updated[index].is_active;
    setAvailability(updated);
  };

  // ✅ Handle time change
  const handleTimeChange = (index: number, key: string, value: string) => {
    const updated = [...availability];
    updated[index][key] = value;
    setAvailability(updated);
  };

  // ✅ Save/Update settings
  const handleSave = async () => {
    setLoading(true);
    const payload = {
      availability,
      exam_auto_acceptance: autoAccept ? "ON" : "OFF",
      examiner_time_zone: timeZone,
    };

    try {
      const res: any = await WebService.postAPI({
        action: "/examiner/settings/update",
        body: payload,
      });
      toast.success(res.message || "Settings updated successfully");
    } catch (error) {
      toast.error("Failed to update settings");   
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h4 className="mb-4">Examiner Settings</h4>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          {/* --- Availability --- */}
          <h6 className="mb-3">Availability</h6>
          <Card className="p-3 mb-4 shadow-sm border-0">
            {availability.map((slot, index) => (
              <Row
                className="align-items-center mb-3"
                key={slot.day_of_week}
                style={{
                  borderBottom: "1px solid #f1f1f1",
                  paddingBottom: 10,
                }}
              >
                <Col xs={12} md={2}>
                  <Form.Check
                    type="switch"
                    id={`switch-${slot.day_of_week}`}
                    label={slot.day_of_week}
                    checked={!!slot.is_active}
                    onChange={() => handleToggle(index)}
                  />
                </Col>
                <Col xs={12} md={4}>
                  <Form.Control
                    type="time"
                    value={slot.start_time || ""}
                    onChange={(e) =>
                      handleTimeChange(index, "start_time", e.target.value)
                    }
                    disabled={!slot.is_active}
                    placeholder="From time"
                  />
                </Col>
                <Col xs={12} md={4}>
                  <Form.Control
                    type="time"
                    value={slot.end_time || ""}
                    onChange={(e) =>
                      handleTimeChange(index, "end_time", e.target.value)
                    }
                    disabled={!slot.is_active}
                    placeholder="To time"
                  />
                </Col>
              </Row>
            ))}
          </Card>

          {/* --- Exam Auto Acceptance --- */}
          <h6 className="mb-3">Exam Auto Acceptance</h6>
          <Form.Check
            type="switch"
            id="autoAccept"
            label={autoAccept ? "ON" : "OFF"}
            checked={autoAccept}
            onChange={() => setAutoAccept(!autoAccept)}
            className="mb-4"
          />

          {/* --- Max Capacity --- */}
          {/* <Form.Group className="mb-4">
            <Form.Label>Exam Amount</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter max capacity"
              value={examAmount}
              onChange={(e) => setExamAmount(e.target.value)}
              
            />
          </Form.Group> */}

          {/* --- Time Zone --- */}
          <Form.Group className="mb-4">
            <Form.Label>Examiner Time Zone</Form.Label>
            <Form.Select
              value={timeZone}
              onChange={(e) => setTimeZone(e.target.value)}
            >
              {timeZones.map((tz) => (
                <option key={tz} value={tz}>
                  {tz}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* --- Save Button --- */}
          <div className="text-end mt-4">
            <Button
              variant="primary"
              onClick={handleSave}
              style={{
                background: "#00B3A4",
                border: "none",
                padding: "8px 32px",
                borderRadius: "8px",
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" animation="border" className="me-2" />
                </>
              ) : (
                "Save Settings"
              )}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ExaminerSettings;
